var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"referral-edit"},[_c('edit',{attrs:{"fs":_vm.referralFields,"api":"referrals","id":_vm.id,"title":"Referral"},on:{"saved":_vm.saved}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }